var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 8 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 4.13397C8.16667 4.51888 8.16667 5.48113 7.5 5.86603L1.83975 9.13397C1.17308 9.51887 0.339745 9.03775 0.339745 8.26795L0.339745 1.73205C0.339745 0.96225 1.17308 0.481125 1.83975 0.866025L7.5 4.13397Z"
  })));
};
export default SvgPlay;